module.exports = __webpack_public_path__ + "static/sc21banner-862b5120bf5a7b25b11b9f2f7da0f77d.jpeg";